import React from "react";

export const TechExpo= ()=>{

    return (
        <div className="lg:flex justify-center items-center DISPLAY">
          <div className="flex flex-col justify-center items-center lg:w-[700px] lg:h-[600px] mr-14 space-y-6 px-4 ADJUSTMENT23">
            <div className="text-5xl text-transparent  bg-clip-text bg-gradient-to-r from-[#B24592] to-[#F15F79] font-bold adjust_size">
              TechExpo
            </div>
            <div className="text-justify text-[1.2rem] text-base ">
            
      <p>•The Tech Expo is a flagship segment of Scientific, designed to spotlight the innovative spirit of IIIT-NR students.</p>
            
      <p>•This event provides a unique platform for students to exhibit their cutting-edge projects, offering visiting students a glimpse into the remarkable research and development taking place at the institute.</p>
            
      <p>•In addition to project showcases, the expo hosts engaging tech talks by students and experts, delving into the latest advancements in Artificial Intelligence and emerging technologies.</p>
            
      <p>•The Tech Expo aims to inspire curiosity, foster collaboration, and bridge the gap between theoretical knowledge and practical innovation.</p>
            </div>
            
          </div>
        </div>
      );
}